import api from "./api";

class WorkTypesServiceClass {
	getWorkTypes() {
		return api.get("work-types").then((res) => res.data);
	}
}

export default new WorkTypesServiceClass();
